export default [
  {
    key: 'toMerchantId',
    label: 'field.merchant',
    rules: 'required',
    type: 'async-single-selection',
    repository: 'partnersShip',
    selectionKey: 'id',
    selectionLabel: 'companyName',
    cols: 12,
  },
]